import { jwtDecode } from 'jwt-decode';

export class UserContext {
  private jwt_token: string;
  private data: any;

  public get issuer(): string {
    return this.data.iss;
  }

  public get userProfileUId(): string {
    return this.data.sub;
  }

  public get audience(): string {
    return this.data.aud;
  }

  public get expiration(): number {
    return this.data.exp;
  }

  public get issuedAt(): string {
    return this.data.iat;
  }

  public get jwtIdentifier(): string {
    return this.data.jti;
  }

  public get organizationUId(): string {
    return this.data['tai-org'];
  }

  public get organizationCode(): string {
    return this.data['tai-org-cd'];
  }

  public get organizationDisplayName(): string {
    return this.data['tai-org-dis'];
  }

  public get email(): string {
    return this.data['tai-eml'];
  }

  public get displayName(): string {
    return this.data['tai-nam'];
  }

  public get cultureCode(): string {
    return this.data['tai-cul'];
  }

  public get fallbackCultureCode(): string {
    return this.data['tai-fcul'];
  }

  public get timezone(): string {
    return this.data['tai-tmz'];
  }

  public get dateTimeFormat(): string {
    return this.data['tai-dtf'];
  }

  public get distanceUnit(): string {
    return this.data['tai-dis'];
  }

  public get permissions(): number[] {
    return this.data['tai-per'];
  }

  public get sessionUId(): string {
    return this.data['tai-sid'];
  }

  public get tokenType(): string {
    return this.data['tai-typ'];
  }

  public get jwtToken(): string {
    return this.jwt_token;
  }

  public get token(): string {
    return this.data;
  }

  public get isReadOnlyToken(): boolean {
    return this.data['tai-read-only-tkn'];
  }

  public get isInheritedToken(): boolean {
    return this.data['tai-inh-tkn'];
  }

  public get isExternalLink(): boolean {
    return this.data['tai-external-lnk'];
  }

  public get linkedDatasetUIds(): string[] {
    return this.data['tai-lms'];
  }

  public get isPreferenceToken(): boolean {
    return this.data['tai-prf-tkn'];
  }

  public get linkedMapUId(): string {
    return this.data['tai-lds'];
  }

  public get defaultRoute(): string {
    return this.data['tai-def-rt'];
  }

  public get acceptedPolicy(): boolean {
    return this.data['tai-acc-pol'];
  }

  public get useNewCommunicationsModule(): boolean {
    // return this.data['tai-use-new-coms'];
    return true;
  }

  public get businessUnitUId(): string {
    return this.data['tai-bu-uid'];
  }

  public get businessUnitSecurityGroupUId(): string {
    return this.data['tai-bu-sg-uid'];
  }

  public get needsBusinessUnit(): boolean {
    return this.data['tai-needs-unit'];
  }

  public get businessUnitHasChildren(): boolean {
    return this.data['tai-bu-has-child'];
  }

  constructor(token: string) {
    this.jwt_token = token;
    this.data = jwtDecode(token);
  }

  hasPermission(permissionToCheck: number[]) {
    const [slot, permission] = permissionToCheck;

    // eslint-disable-next-line no-bitwise
    const permissionValue = this.permissions.length > slot ? this.permissions[slot] : 0;
    if ((permissionValue & permission) === permission) {
      return true;
    }

    return false;
  }
}
